import { FC } from 'react'
import { Post } from '@wellesley/openapi'

const Header: FC<Post> = (post) => {
  return (
    <div className="flex">
      <p className="text-lg font-medium text-gray-700">{post.title}</p>
    </div>
  )
}

export default Header
